import PropTypes from 'prop-types';
import React, { Component } from 'react';
import classNames from 'classnames';
import 'js/../stylesheets/user/mentions_settings.scss';
import $image_url from 'js/utils/image_url';

export class ConfirmedName extends Component {
  constructor(props) {
    super(props);
  }

  render() {
    const nameBoxContainerClasses = classNames(
      'TextInput TextInput--md auto-width u-bgColorWhite u-ph0x',
      {
        'u-mb4x': !this.props.modalMode,
      },
    );
    return (
      <div className="row col-xs-12">
        <div className={nameBoxContainerClasses}>
          <div className="u-floatLeft display-name-box u-fw500 u-fs16 u-lineHeight1 u-tcGrayDarkest">
            {this.props.displayName}
            <img
              src={$image_url('icons/trash-s14.svg')}
              className="u-clickable add-name-icon u-ml2x"
              onClick={() => this.props.onDelete(this)}
            />
          </div>
        </div>
      </div>
    );
  }
}
ConfirmedName.propTypes = {
  onDelete: PropTypes.func.isRequired,
  displayName: PropTypes.string.isRequired,
  id: PropTypes.number.isRequired,
  modalMode: PropTypes.bool,
};
